import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoomDetailComponent } from './room-detail.component';
import { RoomDetailRoutingModule } from './room-detail-routing.module';
import { SearchFormModule } from 'src/app/libs/ui/components/search-form/search-form.module';
import { TicketHeroModule } from 'src/app/libs/ui/components/ticket-hero/ticket-hero.module';
import { StarsRatingModule } from 'src/app/libs/ui/components/stars-rating/stars-rating.module';
import { HotelStarsModule } from "../../../../libs/ui/components/hotel-stars/hotel-stars.module";
import { CurrencyExchangeConverterModule } from 'src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
    declarations: [
        RoomDetailComponent
    ],
    imports: [
        CommonModule,
        RoomDetailRoutingModule,
        SearchFormModule,
        TicketHeroModule,
        I18nModule.forRoot(AppSupportedLanguages),
        // RoomSummaryModule,
        StarsRatingModule,
        HotelStarsModule,
        CurrencyExchangeConverterModule,
        MatTooltipModule
    ],
    exports: [
        RoomDetailComponent
    ]
})
export class RoomDetailModule { }
